<template>
  <div class="mt-3 d-flex justify-content-between align-items-center">
    <b-pagination
      v-model="page"
      :per-page="pageSize"
      :total-rows="$props.total"
      size="sm"
      class="my-0"
    ></b-pagination>

    <div class="small d-flex align-items-center">
      <span>Show</span>

      <b-select
        v-model="pageSize"
        :options="[100, 200, 500, 1000]"
        size="sm"
        class="mx-2"
      ></b-select>

      <span>entries</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'BDXStatusPendingManagerListPagination',
  props: {
    value: {
      type: Object,
      default: () => ({
        page: 1,
        page_size: 100
      })
    },
    total: {
      type: Number,
      required: true
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const page = computed({
      get: () => props.value.page,
      set: (newPage) =>
        emit('input', {
          ...props.value,
          page: newPage
        })
    })

    const pageSize = computed({
      get: () => props.value.page_size,
      set: (newPageSize) =>
        emit('input', {
          ...props.value,
          page_size: newPageSize
        })
    })

    return {
      page,
      pageSize
    }
  }
})
</script>

<style scoped>
.pagination >>> .page-item .page-link {
  min-width: 30px;
  max-width: 30px;
  padding: 4px 0;
  text-align: center;
  border-radius: 4px;
}
</style>
